import { render, staticRenderFns } from "./VehicleQuickActions.vue?vue&type=template&id=2d8ef175&scoped=true"
import script from "./VehicleQuickActions.vue?vue&type=script&lang=js"
export * from "./VehicleQuickActions.vue?vue&type=script&lang=js"
import style0 from "./VehicleQuickActions.vue?vue&type=style&index=0&id=2d8ef175&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ef175",
  null
  
)

export default component.exports